import React from 'react';

interface State {
  hasError: boolean;
  message: string;
}

export class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: unknown): State {
    const message =
      error instanceof Error ? error.message : 'An unexpected error occurred.';
    return { hasError: true, message };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    // Log to the browser console so operators can copy the stack from DevTools.
    console.error('[AppErrorBoundary] Unhandled render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="grid h-full min-h-screen place-items-center bg-slate-100 p-8 text-center">
          <div className="max-w-sm space-y-4">
            <p className="text-lg font-semibold text-ink">Something went wrong.</p>
            <p className="text-sm text-ink-subtle">
              An unexpected error occurred. Reloading usually fixes this.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-primary"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
